<template>
  <div id="app">
    <!-- Main Content -->
    <main>
      <HeroSection />
      <ExperienceSection />
      <!-- <ProjectsSection /> -->
      <SkillsSection />
      <ContactSection />
    </main>

    <!-- Footer -->
    <footer class="footer">
        <div class="footer-main">
        <div class="footer-bottom">
          <p class="made-with-love">
            Made with <i class="fas fa-heart heart"></i> in Bharat
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import HeroSection from './components/HeroSection.vue'
import ExperienceSection from './components/ExperienceSection.vue'
// import ProjectsSection from './components/ProjectsSection.vue'
import SkillsSection from './components/SkillsSection.vue'
import ContactSection from './components/ContactSection.vue'

export default {
  name: 'App',
  components: {
    HeroSection,
    ExperienceSection,
    // ProjectsSection,
    SkillsSection,
    ContactSection
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main Content */
main {
  flex: 1;
}

/* Footer */
.footer {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  color: white;
  padding: 2rem 0;
  position: relative;
  overflow: hidden;
  box-shadow: 0 -10px 30px rgba(102, 126, 234, 0.3);
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #ffffff, transparent);
  opacity: 0.6;
}



.footer-main {
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-bottom {
  text-align: center;
}

.footer-bottom p {
  margin: 0;
}

.made-with-love {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 1.1rem;
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.heart {
  color: #ff4757;
  animation: heartbeat 1.8s ease-in-out infinite;
  font-size: 1.2rem;
  filter: drop-shadow(0 2px 4px rgba(255, 71, 87, 0.4));
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    gap: 1rem;
  }
  
  .nav-menu {
    gap: 1rem;
  }
  
  main {
    margin-top: 120px;
  }
  
  /* Footer Mobile Styles */
  .footer {
    padding: 1.5rem 0;
  }
  
  .made-with-love {
    font-size: 1rem;
    gap: 0.4rem;
  }
  
  .heart {
    font-size: 1.1rem;
  }
}
</style>